export default __webpack_public_path__ + "static/media/PhotoResistorImg.51b22ead.jpg";